export default {
  name: "Job Description",
  prefix: "F.a",
  sections: [
    {
      fields: [
        {
          code: "F.a.1",
          machine_name: "jobTitle",
          widget: "text",
          label: "Job title",
          maxLength: 60,
          validate: ["required"],
          tooltip: "Enter the title of the job opportunity.",
        },
        {
          code: "F.a.2",
          machine_name: "jobDuties",
          widget: "text_area",
          label:
            "Job duties: Description of the specific services or labor to be performed. (All job duties must be disclosed.  A description of the job duties MUST begin in this space.)",
          width: 8,
          rows: 10,
          inputLimit: 4000,
          validate: ["required"],
          tooltip: `Describe the job duties, in detail, to be performed by any worker filling the job opportunity. Specify the field(s) and/or product(s)/industry(ies) involved, any equipment to be used, and pertinent working conditions.  The duties provided must be specific enough to be classified under a relevant Standard Occupational Classification (SOC) code pursuant to the O*NET publication at <a href="https://www.onetonline.org/" target="_blank" rel="noopener noreferrer">https://www.onetonline.org/</a>.  All job duties must be disclosed.  A description of the job duties must begin in the space provided on the form.`,
        },
        // {
        //   isGroup: {
        //     code: "F.a.2",
        //     machine_name: "jobDutiesFiles",
        //     name: "Job Duties",
        //     label: "Document Upload - Job Duties (Optional)",
        //     coloring: "none",
        //     fields: [
        //       {
        //         widget: "file_upload",
        //         machine_name: "jobDutiesFiles",
        //         name: "Job Duties",
        //         uploadTitle: "Document Upload",
        //         label: "Uploaded Job Duties Document",
        //         labelHidden: true,
        //         accept_multiple: true,
        //         // accept_multiple_warning_message: `The upload in this section is limited to the signature of the person authorized to file on behalf of the employer. Additional document uploads are not permitted with the Agricultural Clearance Order, but may be uploaded with the Form ETA-9142A.`,
        //         // update_time: 'eta_790a_i6_date_signed',
        //         dontShowAsterisk: false,
        //         fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
        //         tooltip: "You may include one separate attachment where the allocated space is insufficient.",
        //       },
        //     ],
        //   },
        // },
        {
          isGroup: {
            code: "F.a.3",
            label: "Does this position supervise the work of other employees?",
            machine_name: "superviseOtherEmp",
            type: "radio",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: 1,
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: 0,
                validate: ["required"],
                clearSchema: ["supervisedSocs"],
              },
            ],
            tooltip: `Mark “Yes” or “No”, whether the job opportunity supervises the work of other employees.
            <ol><li>If “Yes” in question 3, enter the SOC code(s) and SOC title(s), of the employees to be supervised.</li></ol>`,
          },
        },
        {
          code: "F.a.3.a",
          machine_name: "supervisedSocs",
          widget: "soc_picker",
          list_options: {
            properties: {
              id: "supervisedSocCode",
              description: "supervisedSocTitle",
              sort: "sort_order",
            },
            max: 10,
          },
          label:
            "If “Yes,” please indicate the SOC code(s) and SOC title(s) of the occupation(s) of the employees to be supervised: § *",
          width: 8,
          rows: 10,
          validate: ["tableRequired", "tableIncomplete"],
          disabled: true,
          disableWhenField: {
            when: "superviseOtherEmp",
            is: 0,
          },
          isVisible: {
            when: "superviseOtherEmp",
            is: 1,
          },
        },
      ],
    },
  ],
};
